import { Box, Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from "@mui/material";

interface ConfirmSubmissionDialogProps {
    open: boolean;
    setOpen: React.Dispatch<React.SetStateAction<boolean>>;
    onConfirm: () => void;
}

export default function ConfirmSubmissionDialog({ open, setOpen, onConfirm }: ConfirmSubmissionDialogProps) {
    return (
        <Dialog
            open={open}
            onClose={() => setOpen(false)}
            aria-labelledby="submission-publish-dialog-title"
            aria-describedby="submission-publish-dialog-description"
            maxWidth="sm"
            fullWidth
            PaperProps={{
                sx: {
                    borderRadius: 3,
                    boxShadow: "0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04)",
                    overflow: 'visible'
                }
            }}
        >
            <DialogTitle id="submission-publish-dialog-title" sx={{ fontWeight: 'bold' }} >
                Confirm Submmission
            </DialogTitle>

             <DialogContent>
                <DialogContentText 
                    id="submission-dialog-description" 
                    sx={{ 
                        color: 'text.secondary',
                        fontSize: '0.95rem',
                        lineHeight: 1.6,
                    }}
                >
                    Are you sure you want to submit this assessment, if this assessment doesn't support multiple 
                    submissions, you wouldn't be able to re-submit.
                </DialogContentText>
            </DialogContent>

            <DialogActions sx={{ px: 3, pb: 2 }}>
                 <Button
                    onClick={() => setOpen(false)}
                    variant="outlined"
                    sx={{ 
                        borderRadius: 2,
                        textTransform: 'none',
                        fontWeight: 500,
                        px: 3,
                        py: 1,
                        borderColor: '#d1d5db',
                        color: '#6b7280',
                        '&:hover': {
                            borderColor: '#9ca3af',
                            backgroundColor: '#f9fafb'
                        }
                    }}
                >
                    Cancel
                </Button>

                 <Button
                    onClick={onConfirm}
                    variant="contained"
                    sx={{ 
                        backgroundColor: "#10b981",
                        borderRadius: 2,
                        textTransform: 'none',
                        fontWeight: 600,
                        px: 4,
                        py: 1,
                        boxShadow: '0 4px 12px -2px rgba(16, 185, 129, 0.3)',
                        '&:hover': {
                            backgroundColor: "#059669",
                            boxShadow: '0 8px 20px -4px rgba(16, 185, 129, 0.4)',
                            transform: 'translateY(-1px)'
                        },
                        transition: 'all 0.2s ease'
                    }}
                >
                    Confirm
                </Button>
            </DialogActions>
        </Dialog>
    )    
}